export default "__VITE_ASSET__BxDbqYeZ__"